import { lazy } from 'react';
import { melioIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/fees-management';

const MainView = lazy(
  () =>
    import(/* webpackChunkName: "FeesManagementRoutes" */ '../pages/MainView')
);

export const feesManagementRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Fees management',
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: false,
      icon: melioIcon,
      pages: []
    }
  ]
};
